const USER_ROLE = {
  SALES_RO: 'sales-ro',
  SALES: 'sales',
  SALES_POST: 'sales-post',
  SALES_ADVANCE: 'sales-advance',
  CLAIMS: 'claims',
  VIEW_ALL: 'view-all',
  INVOICING: 'invoicing',
  INVOICING_ALL: 'invoicing-all',
  T3_READ: 't3-read',
  T3_MODIFY: 't3-modify',
  CANCELLATION_MANAGEMENT: 'cancellation-management',
};

const BRAND = {
  FCB: 'FCB',
};

export { USER_ROLE, BRAND };
